const quickLinks = [
  { label: '主题合集', href: '#index' },
  { label: '热门榜单', href: '#ranking' },
  { label: '漫画精选', href: '#cards' },
  { label: '焦点专题', href: '#carousel' },
  { label: '精彩推荐', href: '#media' },
  { label: '最新动态', href: '#updates' },
  { label: '联系我们', href: '#contact' },
  { label: '常见问题', href: '#faq' },
];

const partnerNames = [
  '漫画合作站点',
  '动漫资讯平台',
  'ACG社区联盟',
  '漫画汉化组',
  '二次元画师平台',
  '动漫周边商城',
];

export default function Footer() {
  return (
    <footer id="footer" className="bg-secondary-50 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-14 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <a href="#hero" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl text-foreground-900">
                5151漫画网
              </span>
            </a>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4">
              5151漫画网是国内领先的51漫画下载资源平台，提供海量日漫、国漫、韩漫高清资源免费下载与离线缓存服务。
              支持51漫画免费版下载全集离线看，每日同步更新最新连载，是漫画爱好者最值得信赖的一站式阅读伙伴。
            </p>
            <div className="flex items-center gap-3">
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-foreground-600 text-base"></i>
              </a>
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-foreground-600 text-base"></i>
              </a>
              <a href="#contact" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-50 border border-background-200/60 hover:border-primary-200 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-foreground-600 text-base"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.slice(0, 4).map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              更多链接
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.slice(4).map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 mb-4">
              合作伙伴
            </h4>
            <div className="grid grid-cols-2 gap-2">
              {partnerNames.map((name) => (
                <span
                  key={name}
                  className="px-3 py-2 text-xs text-foreground-500 bg-background-50 rounded-lg border border-background-200/60 text-center whitespace-nowrap"
                >
                  {name}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2019-2026 5151漫画网 51漫画下载资源平台 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              返回顶部
            </a>
            <a href="#faq" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              常见问题
            </a>
            <a href="#contact" className="text-xs text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}